module.exports = __webpack_public_path__ + "img/Symbol_L3.c85989b6.png";